import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import lock from "../../Assets/Icon/lock.webp";
import {
  GetHodEmployeeList,
  HodIndentEmployeeActiveList,
  HodIndentResetPassword
} from "../../Repository/Api";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";

const itemsPerPage = 10;

const HodEmployeeList = () => {
  const { first_name, access_token, department } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [employeeList, setEmployeeList] = useState([]);
  // 
  const [validation, setValidation] = useState({});
  const [indendEmployeeList, setIndendEmployeeList] = useState({});
  const [resetPasswordModel, setResetPasswordModel] = useState(false);
  const [createResetPassword, setCreateResetPassword] = useState({});
  const [password, setPassword] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  // search filter indendEmployee
  const [dummyindendEmployee, setDummyIndendEmployee] = useState([]);
  const [searchTextIndendEmployee, setSearchTextIndendEmployee] = useState('')
  const SearchfilteredDataIndendEmployee = dummyindendEmployee?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchTextIndendEmployee.toLowerCase()))
  )
  useEffect(() => {
    if (searchTextIndendEmployee) {
      setIndendEmployeeList(SearchfilteredDataIndendEmployee)
      setCurrentPage(1)
    }
    else {
      setIndendEmployeeList(dummyindendEmployee)
    }
  }, [searchTextIndendEmployee, dummyindendEmployee]);

  // search filter employee
  const [dummyemployeeList, setDummyEmployeeList] = useState([]);
  const [searchText, setSearchText] = useState('')
  const SearchfilteredData = dummyemployeeList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase()))
  )
  useEffect(() => {
    if (searchText) {
      setEmployeeList(SearchfilteredData)
      setCurrentPage(1)
    }
    else {
      setEmployeeList(dummyemployeeList)
    }
  }, [searchText, dummyemployeeList]);


  useEffect(() => {
    getEmployeeList();
    getIndendEmployeeList();
  },[]);

  const getEmployeeList = async () => {
    const response = await GetHodEmployeeList(token);
    if (response && response.statusCode === 200) {
      // setEmployeeList(response?.data?.employee_details);
      
      setDummyEmployeeList(response?.data?.employee_details)
    } else {
      errorMsg(response.message);
    }
  };
  const getIndendEmployeeList = async () => {
    const response = await HodIndentEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setIndendEmployeeList(response?.data?.employee_details);
      setDummyIndendEmployee(response?.data?.employee_details)
    } else {
      errorMsg(response.message);
    }
  };

  const employeeListArray = Array.isArray(employeeList) ? employeeList : [];
  const employeeIndentListArray = Array.isArray(indendEmployeeList)
    ? indendEmployeeList
    : [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employeeListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const currentItemsIndent = employeeIndentListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [active, setActive] = useState(0);
  const links = ["Employee", "Indender"];
  const showSelected = (index) => {
    setActive(index);
  };

  const [activeEmployee, setActiveEmployee] = useState(0);
  const linksEmployee = ["Active", "Inactive", "Releaved"];
  const showSelectedEmployee = (index) => {
    setActiveEmployee(index);
  };
  const [activeIndend, setActiveIndend] = useState(0);
  const linksIndend = ["Active", "Inactive"];
  const showSelectedIndend = (index) => {
    setActiveIndend(index);
  };

  const activeLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "active").length
    : 0;
  const inactiveLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "inactive").length
    : 0;
  const releavedLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "releaved").length
    : 0;
  const activeIndentLength = Array.isArray(currentItemsIndent)
    ? currentItemsIndent.filter((item) => item.status === "active").length
    : 0;
  const inactiveIndentLength = Array.isArray(currentItemsIndent)
    ? currentItemsIndent.filter((item) => item.status === "inactive").length
    : 0;

  const setData = (e, key) => {
    setCreateResetPassword({ ...createResetPassword, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    const Payload = {
      id: createResetPassword.id,
      password: createResetPassword.password,
    };
    const response = await HodIndentResetPassword(Payload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setCreateResetPassword({});
      setResetPasswordModel(false);
      e.target.reset();
      getEmployeeList();
      getIndendEmployeeList();
    } else {
      errorMsg(response.message);
    }
  };
  const viewPassword = () => {
    setPassword(!password);
  };



  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-2">
                    <h6 className="labeltitle">Employee List</h6>
                  </div>
                  <div className="col-lg-8">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="scroll-table">
                  {active === 0 && (
                    <>
                      <div className="mt-3">
                        <ul className="searchtopflex">
                          {linksEmployee.map((linkEmp, index) => {
                            return (
                              <li
                                onClick={() => showSelectedEmployee(index)}
                                key={linkEmp}
                                className={
                                  activeEmployee === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linkEmp}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
                            <input type="text" class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      {activeEmployee === 0 && (
                        <div>
                          <table className="table table-hover mt-2">
                            <thead>
                              <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Designation</th>
                                <th scope="col">Department</th>
                                <th scope="col">Employee ID</th>
                                <th scope="col">Email Id</th>
                                <th scope="col">Phone No</th>
                                <th scope="col">More Info</th>
                              </tr>
                            </thead>
                            <tbody>
                              {activeLength > 0 ? (
                                currentItems &&
                                currentItems
                                  ?.filter((item) => item.status === "active")
                                  ?.map((employee, index) => (
                                    <tr key={index}>
                                      <td>
                                        {employee?.first_name
                                          ? employee?.first_name
                                          : "-"}
                                        &nbsp;
                                        {employee?.last_name
                                          ? employee?.last_name
                                          : "-"}
                                      </td>
                                      <td className="textformat">
                                        {employee?.designation
                                          ? employee?.designation
                                          : "-"}
                                      </td>
                                      <td className="textformat">
                                        {employee?.department
                                          ? employee?.department
                                          : "-"}
                                      </td>
                                      <td>
                                        {employee?.employee_id
                                          ? employee?.employee_id
                                          : "-"}
                                      </td>
                                      <td>
                                        {employee?.email_id
                                          ? employee?.email_id
                                          : "-"}
                                      </td>
                                      <td>
                                        {employee?.phone_number
                                          ? employee?.phone_number
                                          : "-"}
                                      </td>

                                      <td className="viewoption">
                                        <Link
                                          to={`/app/Hod/HodEmployeeSpecificView/${employee?.id}`}
                                        >
                                          View Details
                                        </Link>
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>

                                  <td colSpan={7}>
                                    <div> No Data Found</div>
                                  </td>

                                </tr>
                              )}
                            </tbody>
                            <tfoot>
                              <td></td>
                              <td></td>
                              <td colSpan="4">
                                <div className="mt-5">
                                  {Array.from({
                                    length: Math.ceil(
                                      employeeList.length / itemsPerPage
                                    ),
                                  }).map((page, index) => (
                                    <button
                                      key={index}
                                      onClick={() => paginate(index + 1)}
                                      className="paginationbutton"
                                    >
                                      {index + 1}
                                    </button>
                                  ))}
                                </div>
                              </td>
                            </tfoot>
                          </table>
                        </div>
                      )}
                      {activeEmployee === 1 && (
                        <table className="table table-hover mt-2">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Hod/HodEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan={7}>
                                  <div> No Data Found</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                      {activeEmployee === 2 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {releavedLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "releaved")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Hod/HodEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan={7}>
                                  <div> No Data Found</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 1 && (
                    <>
                      <div className="mt-3">
                        <ul className="searchtopflex">
                          {linksIndend.map((linksInd, index) => {
                            return (
                              <li
                                onClick={() => showSelectedIndend(index)}
                                key={linksInd}
                                className={
                                  activeIndend === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linksInd}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
                            <input type="text" class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextIndendEmployee}
                              onChange={(e) => setSearchTextIndendEmployee(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      {activeIndend === 0 && (
                        <table className="table table-hover mt-3">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Indent ID</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                              <th scope="col">Reset Password</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeIndentLength > 0 ? (
                              currentItemsIndent &&
                              currentItemsIndent
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Hod/HodEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                    <td
                                      className="resetbuttonoption"
                                      onClick={() => {
                                        setResetPasswordModel(true);
                                        setCreateResetPassword(employee);
                                      }}
                                    >
                                      <span className="material-symbols-outlined">
                                        lock_reset
                                      </span>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <div> No Data Found</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <td></td>
                            <td colSpan="4">
                              <div className="mt-5">
                                {Array.from({
                                  length: Math.ceil(
                                    indendEmployeeList.length / itemsPerPage
                                  ),
                                }).map((page, index) => (
                                  <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className="paginationbutton"
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                              </div>
                            </td>
                          </tfoot>
                        </table>
                      )}
                      {activeIndend === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveIndentLength > 0 ? (
                              currentItemsIndent &&
                              currentItemsIndent
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Hod/HodEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan={5}>
                                  <div> No Data Found</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Reset Password Model */}
        <CustomModal
          open={resetPasswordModel}
          onClickOutside={() => {
            setResetPasswordModel(false);
          }}
        >
          <form
            onSubmit={(e) => {
              handleUpdatePassword(e);
            }}
          >
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Reset Password</h5>
              </div>
              <div className="modal-body p-0">
                <div className="container">
                  <div className="row mt-2">
                    <div className="col-lg-8 mx-auto ms-auto">
                      <div className="inputspace">
                        <label className="labeltext mb-3">Reset Password</label>
                        <img className="icon" src={lock} alt="User" />
                        <input
                          type={password ? "text" : "password"}
                          className="input-fieldreset"
                          placeholder="PASSWORD"
                          defaultValue={createResetPassword.password}
                          onChange={(e) => {
                            setData(e.target.value, "password");
                          }}
                        />
                        <div className="psw-iconreset">
                          {password ? (
                            <span
                              className="material-symbols-rounded align-middle"
                              onClick={() => viewPassword()}
                            >
                              visibility
                            </span>
                          ) : (
                            <span
                              className="material-symbols-rounded  align-middle"
                              onClick={() => viewPassword()}
                            >
                              visibility_off
                            </span>
                          )}
                        </div>
                        {validation.password && (
                          <p className="validationmsg">{validation.password}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div>
                  <button
                    type="button"
                    className="btn mx-2 submit-btn"
                    onClick={() => {
                      setResetPasswordModel(false);
                      setValidation({});
                      setCreateResetPassword({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 submit-btn">
                    Reset Password
                  </button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default HodEmployeeList;
